/**
 * @generated SignedSource<<8a1bed261cc739cefdbf4bfbeba630ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DrawingSetSheetBatchSavingInput = {
  sheets: ReadonlyArray<DrawingSetSheetBatchSavingSheetInput>;
};
export type DrawingSetSheetBatchSavingSheetInput = {
  isRemoved?: boolean | null | undefined;
  name?: string | null | undefined;
  number?: string | null | undefined;
  order?: number | null | undefined;
  sheetId: string;
};
export type drawingSetSheetBatchSavingMutation$variables = {
  input: DrawingSetSheetBatchSavingInput;
};
export type drawingSetSheetBatchSavingMutation$data = {
  readonly drawingSetSheetBatchSaving: {
    readonly updatedSheets: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"drawingSetSheetFragment">;
    }>;
  };
};
export type drawingSetSheetBatchSavingMutation = {
  response: drawingSetSheetBatchSavingMutation$data;
  variables: drawingSetSheetBatchSavingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "drawingSetSheetBatchSavingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetSheetSavingOutput",
        "kind": "LinkedField",
        "name": "drawingSetSheetBatchSaving",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DrawingSetSheet",
            "kind": "LinkedField",
            "name": "updatedSheets",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "drawingSetSheetFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "drawingSetSheetBatchSavingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetSheetSavingOutput",
        "kind": "LinkedField",
        "name": "drawingSetSheetBatchSaving",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DrawingSetSheet",
            "kind": "LinkedField",
            "name": "updatedSheets",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdById",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "versionDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "drawingSetId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "number",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRemoved",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "order",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revision",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c4938764a1c73d7b17ee277f4bd5c2aa",
    "id": null,
    "metadata": {},
    "name": "drawingSetSheetBatchSavingMutation",
    "operationKind": "mutation",
    "text": "mutation drawingSetSheetBatchSavingMutation(\n  $input: DrawingSetSheetBatchSavingInput!\n) {\n  drawingSetSheetBatchSaving(input: $input) {\n    updatedSheets {\n      ...drawingSetSheetFragment\n      id\n    }\n  }\n}\n\nfragment drawingSetSheetFragment on DrawingSetSheet {\n  id\n  createdAt\n  updatedAt\n  createdById\n  versionDate\n  drawingSetId\n  number\n  name\n  isRemoved\n  order\n  revision\n}\n"
  }
};
})();

(node as any).hash = "bdd2989462508bb8acbdc8bb3cf48a96";

export default node;
